var mentions_default = {
  "mentionPalette": "rr7OX",
  "mention": "_10jai",
  "mentionViewer": "Joeea",
  "mentionSuggestionsEntry": "erjml",
  "mentionSuggestionsEntryFocused": "VI4f0",
  "mentionSuggestionsEntryText": "aLDBH",
  "mentionSuggestionsEntryAvatar": "_6yCtO",
  "mentionSuggestions": "Inp2J",
  "cursorDefault": "-qvGE",
  "cursorPointer": "_2V6vv"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
